import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseService } from '../../../../shared/services/base.service';
@Injectable({ providedIn: 'root' })
export class HealthService extends BaseService {
    getListBeneficiaryAdesao() {
        let url = environment.portalApi + '/health/ListBeneficiaryAdesao';
        return this.http.get(url, { headers: this.createHeader() });
    }
    getTermoLgpdPdf() {
        const url = environment.portalApi + '/Health/TermoMenorLGPD';
        return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
    }
    getCartoesDigital(value: any) {
        let url = environment.portalApi + '/Health/GetCarteirinhas';
        return this.http.get(url, { headers: this.createHeader() });
    }
    getProfessionalCouncil() {
        let url = environment.portalApi + '/health/ProfessionalCouncil';
        return this.http.get(url, { headers: this.createHeader() });
    }
    getServiceStatus() {
        let url = environment.portalApi + '/health/servicestatus';
        return this.http.get(url, { headers: this.createHeader() });
    }
    getRequestStatus() {
        let url = environment.portalApi + '/health/requestStatus';
        return this.http.get(url, { headers: this.createHeader() });
    }
    getFinancialStatus() {
        let url = environment.portalApi + '/health/financialstatus';
        return this.http.get(url, { headers: this.createHeader() });
    }
    getStatementComplete(filter: any) {
        if (!filter.period && !filter.initialDate)
            filter.period = 30;
        let url = environment.portalApi + '/health/StatementComplete?' + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader() }).pipe(shareReplay());
    }
    getHealthCostComplete() {
        let url = environment.portalApi + '/health/CostComplete?';
        return this.http.get(url, { headers: this.createHeader() });
    }
    getHistoryComplete(filter: any) {
        let url = environment.portalApi + '/health/historyComplete?' + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader() });
    }
    getHistoryCompletePaginated(filter: any) {
        let url = environment.portalApi + '/health/historyCompletePaginated?' + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader() });
    }
    getBeneficiaryAndHealthData() {
        let url = environment.portalApi + '/health/BeneficiaryAndHealthData';
        return this.http.get(url, { headers: this.createHeader() });
    }
    downloadFile(filter: any, dataType: string, fileType: string) {
        let url = environment.portalApi + '/health/' + dataType + fileType + '?' + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
    }
    postDeleteBeneficiary(request: any) {
        const url = `${environment.portalApi}/health/DeleteBeneficiary`;
        return this.http.post(url, request, { headers: this.createHeader(), responseType: 'blob', observe: 'response' });
    }
    getPendingRequests(filter: any) {
        let url = environment.portalApi + '/health/PendingRequests?' + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader() });
    }
    getStatementPdf(filter: any) {
        const url = environment.portalApi + '/Health/StatementPdf?' + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
    }
    getStatementCsv(filter: any) {
        const url = environment.portalApi + '/Health/StatementCsv?' + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
    }
    getHistoryPdf(filter: any) {
        const url = environment.portalApi + '/Health/HistoryPdf?' + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
    }
    getHistoryCsv(filter: any) {
        const url = environment.portalApi + '/Health/HistoryCsv?' + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
    }
    getBuscarMedicoConselho(filter: any) {
        let url = environment.portalApi + '/health/BuscarMedicoConselho?' + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader() });
    }
    getValidarDocumento(filter: any) {
        let url = environment.portalApi + '/health/ValidarDocumento?' + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader() });
    }
    getBuscarMedico(filter: any) {
        let url = environment.portalApi + '/health/BuscarMedico?' + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader() });
    }
    postCreateBeneficiary(request: any) {
        const url = `${environment.portalApi}/health/CreateBeneficiary`;
        return this.http.post(url, request, { headers: this.createHeader() });
    }
}